import { render, staticRenderFns } from "./app-modal-button.vue?vue&type=template&id=44c4b38a&"
import script from "./app-modal-button.vue?vue&type=script&lang=js&"
export * from "./app-modal-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports